import React, { useEffect, useState } from 'react'
import UserProfileDropdown from '../../components/UserProfile/UserProfile'
import Sidebar from '../../components/Sidebar/Sidebar'
import SeedsLogo from "../../assets/images/SeedsLogo.png";
import './ApplicationStagesDashboard.css';
import StageGrid from './StageGrid/StageGrid';
import { useDispatch, useSelector } from 'react-redux';
import { getApplicationSummary } from '../../redux/ReportsReducer/action';
import { getApplicationDashbordSummary } from '../../redux/ApplicationReducer/action';
import ComponentView from '../../components/ComponentView/ComponentView';

const clientID = process.env.REACT_APP_APPSMITH_CLIENT_ID;

const ApplicationStagesDashboard = () => {

    // let data = [
    //     {
    //         title: "BM Recommendation",
    //         count: 34,
    //         amount: 1000000
    //     }
    // ]

    const { applicationAnalytics, applicationsSummary } = useSelector((store) => {
        return {
            applicationAnalytics: store.ReportsReducer.applicationAnalytics.data,
            applicationsSummary: store.ApplicationReducer.applicationsSummary
        }
    });

    const [analyticsFilters, setAnalyticsFilters] = useState({
        display_name: ''
    });

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getApplicationSummary(analyticsFilters, null));
    }, [dispatch, analyticsFilters]);

    useEffect(() => {
        dispatch(getApplicationDashbordSummary(clientID, "APPLICATIONS_SUMMARY", analyticsFilters));
    }, [dispatch, analyticsFilters]);

  return (
    // <div className="analyticsDashboardContainer">
    //             <div className="analyticsDashboard">
    //                 <Sidebar />
    
    //                 <div className="dashboardMainContent">
    //                     <div className="contentHeader">
    //                         <div className="userLogo">
    //                             <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
    //                         </div>
    //                         <div className="headerRightPanel">
    //                             <UserProfileDropdown />
    //                         </div>
    //                     </div>
                        
    //                     <div className="pageHeaderSection">
    //                         <div className='breadcrumbSection'>
    //                             <div className="pageBreadcrumbs">
    //                                 <span>Home</span> &nbsp;/&nbsp; <span>Analytics</span>
    //                                 <h4>Analytics</h4>
    //                             </div>
    //                         </div>
    //                     </div>

    //                     {/* <div className="stageCardsContainer">
    //                         <div className="stageCard">
                                
    //                         </div>
    //                     </div> */}

    //                     <StageGrid 
    //                         data={applicationAnalytics}
    //                     />
    //                 </div>
    //             </div>
    //         </div>

     <div className="applicationsDashboardContainer">
      <div className="applicationsDashboard">
        <Sidebar />

        <div className="dashboardMainContent">
          <div className="contentHeader">
            <div className="userLogo">
              <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
            </div>
            <div className="headerRightPanel">
              <UserProfileDropdown />
            </div>
          </div>

          <div className='analytics-views-container'>
            {
              applicationsSummary?.map((view) => {
                return (
                  <div className='analytics-single-view' key={view.view_id}>
                    <ComponentView view={view} />
                  </div>
                )
              })
            }
          </div>

        </div>
      </div>
    </div>
  )
}

export default ApplicationStagesDashboard